import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import api from "@/lib/api";

const fmt = (n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

// Hinweis beim Bearbeiten: Paket-/Katalogpreise oder Provision haben sich seit Erstellung geändert.
export default function RepriceBanner({ offerId, onApply }) {
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(false);
  useEffect(() => {
    let alive = true;
    api.get(`/offers/${offerId}/reprice-preview`)
      .then((r) => alive && setInfo(r.data))
      .catch(() => alive && setInfo(null));
    return () => { alive = false; };
  }, [offerId]);
  if (done || !info?.changes?.length) return null;
  const apply = () => {
    if (!window.confirm("Aktuelle Paket-/Katalogpreise inkl. Provision des zuständigen Verkäufers übernehmen?\n\nDanach bitte das Angebot speichern.")) return;
    onApply(info.lines);
    setDone(true);
  };
  return (
    <div className="rounded-2xl border border-amber-500/50 bg-amber-500/8 p-4" data-testid="wp-reprice-banner">
      <div className="flex items-start gap-3 flex-wrap">
        <RefreshCw size={16} className="text-amber-300 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-[220px]">
          <div className="text-[13.5px] font-extrabold text-amber-200">Preise haben sich seit Erstellung geändert</div>
          <div className="text-[12px] text-amber-100/85 mt-0.5" data-testid="wp-reprice-banner-summary">
            {info.changes.length} Position(en) · Netto {fmt(info.old_net)} → <b>{fmt(info.new_net)}</b>
          </div>
          <ul className="mt-1.5 space-y-0.5 text-[11.5px] text-amber-100/75">
            {info.changes.slice(0, 6).map((c, i) => (
              <li key={i} className="truncate">{c.title}: <span className="line-through text-zinc-500">{fmt(c.old)}</span> → {fmt(c.new)}</li>
            ))}
          </ul>
        </div>
        <button type="button" onClick={apply} data-testid="wp-reprice-banner-apply"
          className="h-9 px-3 rounded-lg bg-amber-400 text-[#09090B] text-[12.5px] font-bold hover:bg-amber-300 active:scale-95 transition-transform shrink-0">
          Neue Preise übernehmen
        </button>
      </div>
    </div>
  );
}
